import {
	CLEAR_OFFER_STATUS_MANAGEMENT_STATE,
	GET_ALL_OFFER_STATUS,
	GET_ALL_OFFER_STATUS_SUCCESS,
	GET_ALL_OFFER_STATUS_ERROR,
	GET_OFFER_STATUS_BY_ID,
	GET_OFFER_STATUS_BY_ID_SUCCESS,
	GET_OFFER_STATUS_BY_ID_ERROR,
	CREATE_STATUS,
	CREATE_STATUS_SUCCESS,
	CREATE_STATUS_ERROR,
	UPDATE_STATUS,
	UPDATE_STATUS_SUCCESS,
	UPDATE_STATUS_ERROR,
	DELETE_STATUS,
	DELETE_STATUS_SUCCESS,
	DELETE_STATUS_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const OFFER_STATUS_URL = '/offerStatus';

const defaultState = () => ({
	offerStatusList: [],
	isLoadingOfferStatus: '',
});

const state = defaultState();

const getters = {
	offerStatusList: (state) => state.offerStatusList,
	isLoadingOfferStatus: (state) => state.isLoadingOfferStatus === 'loading',
};

const mutations = {
	[CLEAR_OFFER_STATUS_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_OFFER_STATUS]: (state) => {
		state.isLoadingOfferStatus = 'loading';
	},
	[GET_ALL_OFFER_STATUS_SUCCESS]: (state, data) => {
		state.offerStatusList = data;
		state.isLoadingOfferStatus = 'success';
	},
	[GET_ALL_OFFER_STATUS_ERROR]: (state) => {
		state.isLoadingOfferStatus = 'error';
	},
	[GET_OFFER_STATUS_BY_ID]: (state) => {
		state.isLoadingOfferStatus = 'loading';
	},
	[GET_OFFER_STATUS_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingOfferStatus = 'success';
	},
	[GET_OFFER_STATUS_BY_ID_ERROR]: (state) => {
		state.isLoadingOfferStatus = 'error';
	},
	[CREATE_STATUS]: (state) => {
		state.isLoadingOfferStatus = 'loading';
	},
	[CREATE_STATUS_SUCCESS]: (state) => {
		state.isLoadingOfferStatus = 'success';
	},
	[CREATE_STATUS_ERROR]: (state) => {
		state.isLoadingOfferStatus = 'error';
	},
	[UPDATE_STATUS]: (state) => {
		state.isLoadingOfferStatus = 'loading';
	},
	[UPDATE_STATUS_SUCCESS]: (state, data) => {
		state.isLoadingOfferStatus = 'success';
	},
	[UPDATE_STATUS_ERROR]: (state) => {
		state.isLoadingOfferStatus = 'error';
	},
	[DELETE_STATUS]: (state) => {
		state.isLoadingOfferStatus = 'loading';
	},
	[DELETE_STATUS_SUCCESS]: (state, data) => {
		state.isLoadingOfferStatus = 'success';
	},
	[DELETE_STATUS_ERROR]: (state) => {
		state.isLoadingOfferStatus = 'error';
	},
};

const actions = {
	[GET_ALL_OFFER_STATUS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_OFFER_STATUS);
			localStorage.setItem(`lastReqAdm`, 'offerStatusManagement/GET_ALL_OFFER_STATUS');

			http({
				method: 'GET',
				url: `${OFFER_STATUS_URL}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_OFFER_STATUS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_OFFER_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_OFFER_STATUS_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_OFFER_STATUS_BY_ID);

			http({
				method: 'GET',
				url: `${OFFER_STATUS_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_OFFER_STATUS_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_OFFER_STATUS_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_STATUS]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_STATUS);

			http({
				method: 'POST',
				url: `${OFFER_STATUS_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					commit(CREATE_STATUS_SUCCESS);
					vm.$toastr.s('Status da Oferta criado com sucesso.');
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_STATUS]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_STATUS);

			http({
				method: 'PATCH',
				url: `${OFFER_STATUS_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Status da Oferta editado com sucesso.');
					commit(UPDATE_STATUS_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_STATUS]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_STATUS);

			http({
				method: 'DELETE',
				url: `${OFFER_STATUS_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Status da Oferta excluído com sucesso.');
					commit(DELETE_STATUS_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
